import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/modules/material.module';
import { ReorderContextMenuComponent } from './reorder-context-menu.component';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [ReorderContextMenuComponent],
  exports: [ReorderContextMenuComponent],
})
export class ReorderContextMenuModule {}
